import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import instantChatIcon1 from "../../images/v4/linkGeneration/icons/instantChatIcon1.svg";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import darkGreenCheck from "../../images/v4/industry/education/icons/darkGreenCheck.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import transformBackgroundImage from "../../images/v4/linkGeneration/images/transformBackgroundImage.png";

import partnerSectionBackground from "../../images/v4/linkGeneration/images/partnerSectionBackground.png";

import bestPracticeIcon1 from "../../images/v4/industry/it/icons/bestPracticeIcon1.svg";
import bestPracticeIcon2 from "../../images/v4/industry/it/icons/bestPracticeIcon2.svg";
import bestPracticeIcon3 from "../../images/v4/industry/it/icons/bestPracticeIcon3.svg";
import bestPracticeIcon4 from "../../images/v4/industry/it/icons/bestPracticeIcon4.svg";
import bestPracticeIcon5 from "../../images/v4/industry/it/icons/bestPracticeIcon5.svg";
import bestPracticeIcon6 from "../../images/v4/industry/it/icons/bestPracticeIcon6.svg";

import gridIcon1 from "../../images/v4/industry/it/icons/gridIcon1.svg";
import gridIcon2 from "../../images/v4/industry/it/icons/gridIcon2.svg";
import gridIcon3 from "../../images/v4/industry/it/icons/gridIcon3.svg";
import gridIcon4 from "../../images/v4/industry/it/icons/gridIcon4.svg";
import gridIcon5 from "../../images/v4/industry/it/icons/gridIcon5.svg";
import gridIcon6 from "../../images/v4/industry/it/icons/gridIcon6.svg";
import gridIcon7 from "../../images/v4/industry/it/icons/gridIcon7.svg";

import bestPracticeBg from "../../images/v4/industry/education/images/bestPracticeBg.png";
import industryHeroSectionBg from "../../images/v4/industry/education/images/industryHeroSectionBg.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/it/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/industry/it/images/compareItemImg5.png";

import featureSectionImg from "../../images/v4/industry/it/images/featureSectionImg.png";
import meaningImg from "../../images/v4/industry/it/images/meaningImg.png";
import benifitImg from "../../images/v4/industry/it/images/benifitImg.png";
import bodySectionBg from "../../images/v4/industry/education/images/bodySectionBg.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${industryHeroSectionBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "90px 0 220px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "0",
      paddingBottom: "300px",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(0deg, #005A64 0%, #009A99 100%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  pills: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    // marginTop: "25px",
  },
  pill: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "10px 16px",
    borderRadius: "30px",
    border: "1px solid #CEE9FF",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      padding: "10px 15px",
      "& img": {
        width: "20px",
      },
    },
  },
  experienceContainerHeader: {
    gap: "20px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    "& h2": {
      width: "55%",
    },
    "& p": {
      width: "45%",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      "& h2": {
        width: "100%",
      },
      "& p": {
        width: "100%",
      },
    },
  },
  bodySection: {
    backgroundImage: `url(${bodySectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "top",
    paddingBottom: "300px",
    paddingTop: "260px",
    "& .container:first-child": {
      padding: "30px 0",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-460px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "500px",
      paddingBottom: "240px",
      "& .container:first-child": {
        padding: "30px 15px",
      },
    },
  },
  gridSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    rowGap: "24px",
    marginTop: "60px",
    "@media only screen and (max-width: 600px)": {
      marginTop: "40px",
    },
  },
  gridRow: {
    width: "100%",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: "24px",
    "&.row1": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "&.row2": {
      "& $gridCard": {
        width: "32%",
      },
    },
    "&.row3": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  gridCard: {
    display: "flex",
    flexDirection: "column",
    width: "48%",
    padding: "24px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    background: "#ffffff1a",
    borderRadius: "16px",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    gap: "16px",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100% !important",
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bestPracticeBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      paddingBottom: "170px",
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#fff",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "24px",
    width: "30%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(90deg, #011D32 0%, #00182B 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "75%",
    "@media only screen and (max-width: 600px)": {
      top: "91%",
    },
  },
  stripSection: {
    paddingTop: "280px",
    backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "180px",
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(0deg, #7C35B5 0%, #672A99 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& $supportBox": {
        top: "-830px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  featureSection: {
    padding: "60px 0",
    background: "#F5FAFF",
  },
  featureSectionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "30px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  featureContainerLeft: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  featureContainerRight: {
    width: "50%",
    gap: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "& $cardPointer": {
      alignItems: "flex-start",
      "& img": {
        position: "relative",
        top: "5px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        position: "relative",
        top: "5px",
        width: "20px",
      },
    },
  },
  wpFaq: {
    // padding: "40px 0",
    "& $faqSection": {
      padding: 0,
    },
    background: "#F1FFF9",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  // testimonials: {
  //   paddingBottom: "40px",
  // },
}));

const ItIndustry = () => {
  const classes = useStyles();
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question: "How is CRM used in the IT industry?",
      answer: (
        <>
          CRM in the IT industry is used to manage customer relationships, track
          projects, streamline support processes, and align sales and service
          delivery. It helps IT companies maintain detailed records of client
          interactions, technical requirements, and project histories.
        </>
      ),
    },
    {
      question: "What is CRM in technical support?",
      answer: (
        <>
          CRM in technical support refers to the use of customer relationship
          management tools to manage and track customer issues, streamline
          ticketing processes, and provide efficient, personalised support
          services.
        </>
      ),
    },
    {
      question: "How can CRM help technology services?",
      answer: (
        <>
          CRM can help technology services by providing a centralised platform
          for managing customer interactions, tracking project progress,
          forecasting sales, and analysing service performance. It enables
          better collaboration between teams and helps deliver more personalised
          customer experiences.
        </>
      ),
    },
    {
      question: "What is the best CRM for technology services?",
      answer: (
        <>
          Pepper Cloud CRM is considered one of the best CRM solutions for
          technology services due to its comprehensive feature set tailored for
          IT companies, including project management integration, AI-powered
          insights, and robust security measures.
        </>
      ),
    },
    {
      question:
        "What are three key benefits of using CRM in technology business?",
      answer: (
        <>
          Three key benefits are: improved customer satisfaction through better
          service delivery, increased operational efficiency through automation
          and data centralisation, and enhanced decision-making through
          data-driven insights.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM suitable for small IT companies?",
      answer: (
        <>
          Yes, Pepper Cloud CRM is suitable for small IT companies. It offers
          scalable features and pricing, allowing small businesses to start with
          essential functionalities and expand as they grow.
        </>
      ),
    },
  ];
  const features1 = [
    {
      icon: gridIcon1,
      alt: "",
      heading: "Tailored for tech-savvy teams",
      desc: "Intuitive interface, high customisability, and powerful features cater specifically to IT and tech service businesses.",
    },
    {
      icon: gridIcon2,
      alt: "",
      heading: "Project management integration",
      desc: "Connect your CRM directly with popular tools like Jira, aligning customer data with ongoing tech projects for enhanced productivity.",
    },
  ];
  const features2 = [
    {
      icon: gridIcon3,
      alt: "",
      heading: "Advanced AI capabilities",
      desc: "Leverage cutting-edge artificial intelligence to automate routine tasks, provide real-time sales assistance, and offer instant customer support.",
    },
    {
      icon: gridIcon4,
      alt: "",
      heading: "Comprehensive omnichannel support",
      desc: "Manage customer interactions across multiple platforms, including voice/video calls, social media, and messaging apps, all from a centralised hub.",
    },
    {
      icon: gridIcon5,
      alt: "",
      heading: "Customisable dashboards and analytics",
      desc: "Gain deep insights into your IT services performance with tailored reports and visualisations, empowering data-driven decision-making.",
    },
  ];
  const features3 = [
    {
      icon: gridIcon6,
      alt: "",
      heading: "Robust security measures",
      desc: "Rest easy knowing your sensitive tech industry data is protected by PDPA-approved security features, crucial for maintaining client trust.",
    },
    {
      icon: gridIcon7,
      alt: "",
      heading: "Flexible integrations",
      desc: "Seamlessly connect your CRM with your existing tech stack, including project management tools, accounting software, etc.",
    },
  ];
  const bestPractice = [
    {
      icon: bestPracticeIcon1,
      heading: "Keep it simple",
      desc: "Focus on collecting essential information to increase form completion rates and streamline data entry.",
    },
    {
      icon: bestPracticeIcon2,
      heading: "Centralise customer data",
      desc: "Consolidate all customer information in one place for a comprehensive view of each client's history and needs.",
    },
    {
      icon: bestPracticeIcon3,
      heading: "Automate routine tasks",
      desc: "Utilise workflow automation to free up your IT team's time for more complex problem-solving and innovation.",
    },
    {
      icon: bestPracticeIcon4,
      heading: "Personalise customer interactions",
      desc: "Leverage CRM data to tailor communications and support to each client's specific needs and preferences.",
    },
    {
      icon: bestPracticeIcon5,
      heading: "Integrate with project management tools",
      desc: "Ensure seamless flow of information between customer management and project delivery systems.",
    },
    {
      icon: bestPracticeIcon6,
      heading: "Utilise analytics for decision-making",
      desc: "Regularly review CRM reports and dashboards to inform strategic decisions and improve service delivery.",
    },
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Microsoft Dynamics 365",
    "Zoho CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM stands out as the premier choice for IT and Tech services companies, offering a comprehensive suite of features tailored to the unique needs of the technology sector. This all-in-one solution combines powerful lead management, project integration, and AI-driven insights to streamline operations and boost productivity. With its user-friendly interface and scalable architecture, Pepper Cloud CRM is perfectly positioned to support IT companies of all sizes in their growth journey.",
      img: compareItemImg1,
      alt: "Pepper Cloud - Best real estate CRM software",
      features: [
        {
          title: "Project management integration",
          desc: "Seamlessly connect with Jira and other popular project management tools to align customer data with ongoing tech projects.",
        },
        {
          title: "AI-powered suite",
          desc: "Leverage chatbots, real-time sales assistance, and automated task management to optimise your IT service delivery.",
        },
        {
          title: "Customisable dashboards",
          desc: "Create bespoke visualisations and reports to gain deep insights into your tech business performance.",
        },
        {
          title: "Omnichannel support",
          desc: "Manage customer interactions across multiple platforms, including voice/video calls, social media, and messaging apps.",
        },
        {
          title: "Advanced security features",
          desc: "Ensure data protection with PDPA-approved security measures, crucial for maintaining client trust in the IT sector.",
        },
        {
          title: "Personalisation capabilities",
          desc: "Tailor your marketing and support efforts using data-driven insights for more effective customer engagement.",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot offers a comprehensive CRM platform with robust sales pipeline management features, making it particularly suited for IT businesses aiming to align their sales and marketing efforts. With a user-friendly interface and extensive educational resources, it's an attractive option for tech companies looking to scale their customer relationship management.",
      img: compareItemImg2,
      alt: "HubSpot",
      features: [
        {
          title: "Pipeline builder",
          desc: "Intuitive drag-and-drop pipeline builder for customising sales processes.",
        },
        {
          title: "Marketing automation",
          desc: "Powerful tools for creating and managing marketing campaigns.",
        },
        {
          title: "Sales analytics",
          desc: "Detailed reporting and forecasting capabilities for data-driven decision-making.",
        },
        {
          title: "Customer service hub",
          desc: "Centralised platform for managing support tickets and customer inquiries.",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "Salesforce is a well-established CRM platform offering a wide range of features for IT and Tech services companies. Its extensive customisation options and large marketplace of third-party integrations make it a versatile choice for businesses with complex CRM needs.",
      img: compareItemImg3,
      alt: "Salesforce",
      features: [
        {
          title: "AppExchange marketplace",
          desc: "Access to numerous industry-specific apps and integrations.",
        },
        {
          title: "Einstein AI",
          desc: "AI-powered insights and predictions to enhance decision-making.",
        },
        {
          title: "Customisable workflows",
          desc: "Ability to create automated processes tailored to specific IT service needs.",
        },
        {
          title: "Advanced reporting",
          desc: "Comprehensive analytics tools for tracking business performance.",
        },
      ],
    },
    {
      title: "Microsoft Dynamics 365",
      desc: "Microsoft Dynamics 365 offers a robust CRM solution that integrates seamlessly with other Microsoft products, making it an attractive option for IT companies already invested in the Microsoft ecosystem. Its AI capabilities and strong focus on customer insights provide valuable tools for tech service providers.",
      img: compareItemImg5,
      alt: "Microsoft Dynamics 365",
      features: [
        {
          title: "LinkedIn integration",
          desc: "Enhanced lead generation and networking capabilities.",
        },
        {
          title: "Power BI integration",
          desc: "Advanced data visualisation and reporting tools.",
        },
        {
          title: "AI-driven insights",
          desc: "Intelligent forecasting and customer behaviour analysis.",
        },
        {
          title: "Mixed reality tools",
          desc: "Innovative support options for remote assistance in IT services.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM provides a cost-effective solution for small to medium-sized IT companies, offering a good balance of features and affordability. Its user-friendly interface and mobile accessibility make it a practical choice for tech teams on the go.",
      img: compareItemImg4,
      alt: "Zoho",
      features: [
        {
          title: "Zia AI assistant",
          desc: "AI-powered sales assistant for predictive sales and task automation.",
        },
        {
          title: "Customisable modules",
          desc: "Ability to tailor the CRM to specific IT service offerings.",
        },
        {
          title: "Social media integration",
          desc: "Tools for managing customer interactions across social platforms.",
        },
        {
          title: "Gamification features",
          desc: "Motivational tools to boost sales team performance.",
        },
      ],
    },
  ];
  const industryFeature = [
    {
      title: "Assess your specific needs",
      desc: "Evaluate your company's unique requirements, considering factors like team size, project complexity, and customer base.",
    },
    {
      title: "Consider scalability",
      desc: "Choose a CRM that can grow with your IT business, offering flexible pricing and feature expansion options.",
    },
    {
      title: "Evaluate integration capabilities",
      desc: "Ensure the CRM can seamlessly connect with your existing tech stack, including project management and accounting tools.",
    },
    {
      title: "Check for industry-specific features",
      desc: "Look for CRMs that offer IT-focused functionalities like technical support ticketing and project timeline tracking.",
    },
    {
      title: "Prioritise user-friendliness",
      desc: "Opt for a CRM with an intuitive interface to ensure quick adoption and maximum utilisation by your tech team.",
    },
  ];
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <main>
      <SEO
        title={
          "Best CRM Software for IT & Tech Service Providers | Pepper Cloud"
        }
        pathname={
          "https://peppercloud.com/industry/best-crm-software-for-it-and-tech-service-provider/"
        }
        keywords="crm for it company, crm in it industry, it crm software, crm software for it company, crm for it service providers, best crm for tech companies"
        description={
          "Try the best CRM software built just for IT and Tech service providers' needs - manage customer data, track customer interactions,  automate sales processes and more"
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "How is CRM used in the IT industry?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "CRM in the IT industry is used to manage customer relationships, track projects, streamline support processes, and align sales and service delivery. It helps IT companies maintain detailed records of client interactions, technical requirements, and project histories.",
                },
              },
              {
                "@type": "Question",
                name: "What is CRM in technical support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "CRM in technical support refers to the use of customer relationship management tools to manage and track customer issues, streamline ticketing processes, and provide efficient, personalised support services.",
                },
              },
              {
                "@type": "Question",
                name: "How can CRM help technology services?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "CRM can help technology services by providing a centralised platform for managing customer interactions, tracking project progress, forecasting sales, and analysing service performance. It enables better collaboration between teams and helps deliver more personalised customer experiences.",
                },
              },
              {
                "@type": "Question",
                name: "What is the best CRM for technology services?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is considered one of the best CRM solutions for technology services due to its comprehensive feature set tailored for IT companies, including project management integration, AI-powered insights, and robust security measures.",
                },
              },
              {
                "@type": "Question",
                name: "What are three key benefits of using CRM in technology business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Three key benefits are: improved customer satisfaction through better service delivery, increased operational efficiency through automation and data centralisation, and enhanced decision-making through data-driven insights.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM suitable for small IT companies?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM is suitable for small IT companies. It offers scalable features and pricing, allowing small businesses to start with essential functionalities and expand as they grow.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-18"
              style={{ color: "#0291AE" }}
            >
              IT & tech service industry
            </motion.h1>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Best CRM for IT and tech service companies
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Elevate your sales and customer service with the best CRM software
              for IT and tech service companies. Manage customer relationships,
              streamline operations, and drive growth.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Integrated with your tech stack
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Automate with AI features
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Access on-the-go with mobile CRM
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link className="primaryButton font-20 font-wix-medium font-white">
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.bodySection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                What is an IT and tech CRM?
              </p>
              <p
                className="font-18 font-inter-regular"
                style={{ color: "#BEE7E7" }}
              >
                An IT and tech CRM is a specialised customer relationship
                management system designed to meet the unique needs of
                technology companies. It combines standard CRM features like
                contact management and sales tracking with industry-specific
                tools such as project management integration, technical support
                ticketing, etc. for sales cycle in the IT sector.
              </p>
              <div className={classes.pills}>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    AI-powered
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    WhatsApp capabilities
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    Easy to use
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    24/7 Local support
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    No hidden charges
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={meaningImg}
                alt={"Benefits of WhatsApp link generator"}
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className={classes.experienceContainerHeader}>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Why Pepper Cloud is best CRM software for IT and tech company?
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18"
              style={{ color: "#A2BED3" }}
            >
              Fuel faster growth with centralised data, streamlined workflows,
              and AI-driven insights—all working together to maximise sales and
              efficiency. Boost your growth with the powerful all-in-one Sales
              CRM.
            </motion.p>
          </div>
          <div className={classes.gridSection}>
            <div className={clsx(classes.gridRow, "row1")}>
              {features1.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.heading} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row2")}>
              {features2.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.heading} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row3")}>
              {features3.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.heading} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.compareSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                What are the benefits of using CRM software for IT companies?
              </p>
              <div className={classes.pointers}>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Easily manage complex IT sales cycles with pipeline
                    tracking, opportunity management, and AI-powered
                    forecasting.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Effortlessly integrate CRM data with project management
                    tools to ensure projects are delivered on time.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Boost satisfaction and retention with omnichannel support
                    features and AI chatbots to quickly address queries.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Access powerful analytics and customisable dashboards to
                    gain insights into sales trends and customer behaviour.
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benifitImg}
                alt={
                  "What are the benefits of using CRM software for IT companies?"
                }
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 best CRM software for IT and tech services company in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.featureSection}>
        <div className="container">
          <div className={classes.featureSectionContainer}>
            <div className={classes.featureContainerLeft}>
              <LazyImage
                source={featureSectionImg}
                width={"100%"}
                alt={"How to choose the best CRM software for IT  company"}
              />
            </div>
            <div className={classes.featureContainerRight}>
              <p className="font-wix-medium font-40 color-black1">
                How to choose the best CRM software for IT company
              </p>
              <div className={classes.pointers}>
                {industryFeature.map((point) => (
                  <div className={classes.cardPointer}>
                    <LazyImage source={darkGreenCheck} alt={"pointer"} />
                    <p className="font-18 font-inter-regular color-black1">
                      {point.title}: {point.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              IT CRM software: Best practices
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-black1">
                  {practice.heading}
                </p>
                <p className="font-wix-medium font-16 font-black1">
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>
      </section>
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#F1FFF9"}
          heading={"FAQs - Best CRM software for IT and tech service companies"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              From systems to success: Elevate your IT business with intelligent
              CRM
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ItIndustry;
